import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["algoliaApiKeys"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect } from 'react';
import { useHistory } from '@scentregroup/shared/next/compat/history';
import { useAnalytics } from '../../analytics';
import { useAlgoliaClients } from './use-algolia-clients';
import { logHideSearch } from './analytics';
import SearchModalAutocomplete from './search-modal-autocomplete';
import usePlaceholder from './use-placeholder';
import { useUniversalHeaderSearch } from './use-universal-header-search';
import { useLocalUser } from '../../hooks/use-local-user';
import { makeOffsetlessTimeGetters } from './algolia-helpers';
import useAutocomplete from './search-modal-autocomplete/use-autocomplete';
import { jsx as _jsx } from "react/jsx-runtime";
function useHistoryListener(listener) {
  const history = useHistory();
  useEffect(() => history.listen ? history.listen(listener) : () => null, [listener, history]);
}
const SearchModal = props => {
  const {
    specialSearchKind
  } = useUniversalHeaderSearch();
  const {
    clients,
    country,
    centre,
    isOpen,
    onClose
  } = props;
  const hideManual = () => {
    logHideSearch('');
    onClose();
  };
  useHistoryListener(onClose); // If the URL changes hide the search modal

  const analytics = useAnalytics();
  const user = useLocalUser();
  const onSubmit = async (_event, newQuery) => {
    if (newQuery.length > 0 && true) {
      analytics.trackEvent({
        object: 'Global',
        action: 'Searched',
        properties: _objectSpread(_objectSpread({
          category: 'Search',
          label: 'global_searched',
          search_type: centre ? 'Centre' : 'Westfield Direct'
        }, centre && {
          centre_context: centre.title
        }), {}, {
          keyword: newQuery
        })
      });
      const centrePath = centre ? "/".concat(centre.slug) : '';
      const q = encodeURIComponent(newQuery);
      // TODO when all clients are under one routing
      // use history.push from the router
      window.location.assign("".concat(centrePath, "/search?q=").concat(q));
      // // Required when using history.push:
      // hide() // in the event we're already on /search
      // setIsUiLoading(false)
    }
  };

  const context = {
    centre,
    country,
    specialSearchKind,
    user
  };
  const placeholder = usePlaceholder(context);
  const timeGetters = makeOffsetlessTimeGetters(country, centre);
  const searchContext = _objectSpread(_objectSpread(_objectSpread({}, context), timeGetters), {}, {
    query: ''
  });
  const autocompleteWithState = useAutocomplete(clients, searchContext, onSubmit);
  return /*#__PURE__*/_jsx(SearchModalAutocomplete, {
    backgroundColor: "white",
    placeholder: placeholder,
    baseContext: context,
    onClickClose: hideManual,
    autocompleteWithState: autocompleteWithState,
    isOpen: isOpen,
    "data-id": "search_modal-search_SearchModal_SearchModalAutocomplete"
  });
};
const ModalSearch = props => {
  const {
      algoliaApiKeys
    } = props,
    restOfProps = _objectWithoutProperties(props, _excluded);
  const clients = useAlgoliaClients(algoliaApiKeys);
  if (!clients) {
    return null;
  }
  const searchModalProps = _objectSpread(_objectSpread({}, restOfProps), {}, {
    clients
  });
  return clients ? /*#__PURE__*/_jsx(SearchModal, _objectSpread(_objectSpread({}, searchModalProps), {}, {
    "data-id": "search_modal-search_SearchModal"
  })) : null;
};
export default ModalSearch;